import type { Dayjs } from 'dayjs';

export type DayjsChangeHandler = (value: Dayjs | null) => void;

export type DatePickerOnChangeAdapter = (value: unknown) => void;

export function createDatePickerOnChange(
  handler: DayjsChangeHandler
): DatePickerOnChangeAdapter {
  return (value: unknown) => handler(value as Dayjs | null);
}
